import React from "react";
import _ from "lodash";
import { FormStatus } from 'utils/constants/form-constants';
import MutateTeamRights from 'utils/mutate/team-rights'
import SearchSelectTeamComponent from 'components/management/molecules/SearchSelectTeamComponent'

const ManagementBuildingsComponentsTeamsScene = ({ addedAvailableForTeams = [], readonly = false, building, floor, room, onSubmit }) => {
	
	return (
		<SearchSelectTeamComponent
			selectedTeams={ addedAvailableForTeams }
			readonly={ readonly }
			onSubmit={ ( teams, { callback }) => {
				MutateTeamRights.mutate( _.get( building, 'guid', null ), _.get( floor, 'guid', null ), _.get( room, 'guid', null ), teams, {
					callbackStart: () => {
						callback( FormStatus.LOADING )
					},
					callbackSuccess: (result) => {
						callback( FormStatus.SUCCESS );
						
						// reset the save button
						setTimeout( () => {
							return callback(FormStatus.NONE);
						}, 2000 );
						
						if( _.isFunction( onSubmit ) ) {
							onSubmit()
						}
					},
					callbackError: (result) => {
						callback( FormStatus.ERROR )
					}
				} )
			}}
		/>
	)
}

export default ManagementBuildingsComponentsTeamsScene
